module.exports = __webpack_public_path__ + "static/media/10_CAM.e3943a1a.png";